import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { Record } from 'immutable'
import { FormattedMessage } from 'react-intl'

import { VIRTUAL_LIST_ID, LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import StackPreloader from '../../../StackPreloader'
import Entity from '../../../../../../../../components/Entity'
import VirtualizedList from '../../../../../../../../components/VirtualizedList'

import './style.scss'

@hocConnect
export default class FavouritesContent extends Component {
    static propTypes = {
        favouritesCollection: IPropTypes.list.isRequired,
        getFavourites: PropTypes.func.isRequired,
        loaded: PropTypes.bool.isRequired,
        loading: PropTypes.bool.isRequired,
    }

    constructor(props) {
        super(props)

        if (!this.props.loaded) this.props.getFavourites()
    }

    renderLoader = () => {
        const { loading, loaded } = this.props

        return loading || !loaded ? <StackPreloader /> : null
    }

    renderItem = (index) => {
        const { favouritesCollection } = this.props

        return <Entity key={`entity_${index}`} entity={favouritesCollection.get(index, Record())} />
    }

    renderEmptyFavouritesCollection = () => (
        <div className={'empty-favourites-stack'}>
            <span className={'empty-header'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.emptyHeader`} />
            </span>
            <span className={'empty-text'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.emptyText`} />
            </span>
        </div>
    )

    render() {
        const { favouritesCollection } = this.props

        return (
            <div className={'entity-stack-favorite-content'}>
                {this.renderLoader()}
                {favouritesCollection.size <= 0 && this.renderEmptyFavouritesCollection()}
                <VirtualizedList
                    id={VIRTUAL_LIST_ID}
                    itemsCount={favouritesCollection.size}
                    itemHeight={61}
                    renderItem={this.renderItem}
                />
            </div>
        )
    }
}
